import { useUser } from '%hooks';
import { GetCurrentUserPostsDocument } from '%context/Posts/__generated__/userPosts.generated';
import {
	GetProtegesDocument,
	GetProtegesQuery,
	ProtegesListUpdatedSubscription,
	useProtegesListUpdatedSubscription,
} from './__generated__/getProteges.generated';

export const useProtegesUpdatedSubscription = () => {
	const user = useUser();

	useProtegesListUpdatedSubscription({
		onData: ({ data, client }) => {
			if (!data.data) {
				return;
			}

			client.cache.updateQuery<GetProtegesQuery>({ query: GetProtegesDocument }, (prev) => {
				if (!prev) {
					return {
						currentUser: {
							__typename: 'User',
							proteges: getNewProteges([], data.data),
							superPalOf: [],
							id: user.id,
						},
					};
				}

				return {
					...prev,
					currentUser: {
						...prev.currentUser,
						proteges: getNewProteges(prev.currentUser.proteges, data.data),
					},
				};
			});

			return client.refetchQueries({ include: [GetCurrentUserPostsDocument] });
		},
	});
};

const getNewProteges = (
	prevProteges: GetProtegesQuery['currentUser']['proteges'],
	subscriptionData?: ProtegesListUpdatedSubscription,
) => {
	const newProtege = subscriptionData?.protegesListUpdated.added;
	const removedUuid = subscriptionData?.protegesListUpdated.removedUuid;

	let updatedProteges = [...prevProteges];
	if (newProtege) {
		updatedProteges.unshift(newProtege);
	}

	if (removedUuid) {
		updatedProteges = updatedProteges.filter((protege) => protege.uuid !== removedUuid);
	}

	return updatedProteges;
};
